export const allowedCodesValidation = (allowedCodes = [], value) => {
  if (allowedCodes.length && !allowedCodes.includes(value)) {
    const message = 'web.forgotpassword.phone.errorwrongcountry';
    const error = new Error(message);

    error.displayMessage = message;

    throw error;
  }
};
